import { znNumbers } from 'shared/consts';

export function responseLevelText(level: number) {
    return `${znNumbers[level]}级响应`;

}